import { ref } from "vue";
export function useTaikyoFilePreview() {
    const visibleHasonFileDialog = ref(false);
    const visibleOtherFileDialog = ref(false);
    const selectedIndex = ref("");
    const openHasonPreview = (fileId) => {
        selectedIndex.value = fileId;
        visibleHasonFileDialog.value = true;
    };
    const openOtherPreview = (fileId) => {
        selectedIndex.value = fileId;
        visibleOtherFileDialog.value = true;
    };
    return { visibleHasonFileDialog, visibleOtherFileDialog, selectedIndex, openHasonPreview, openOtherPreview };
}
